import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setItems, initializeFromWindow, setCurrentPage } from '../redux/app/app-slice';
import FilterComponent from './Filter';
import BlockItem from './BlockItem';
import Pagination from '../utils/pagination';

const App = (blockId) => {

    const dispatch = useAppDispatch();
    const { filteredItems, currentPage, perPage, selectedTag, appHeading, appDescription } = useAppSelector((state) => state.app);

    useEffect(() => {
        dispatch(initializeFromWindow());
    }, []);

    const handlePageChange = (page: number) => {
        dispatch(setCurrentPage(page));
    };

    // Calculate pagination
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;
    const currentItems = filteredItems.slice(startIndex, endIndex);

    return (
        <div className="block-inner">


            <div className="filter-block-heading">
                <div className="stack-sm">
                    {appHeading &&
                        <h1 className="h2-style"> {appHeading} </h1>
                    }
                    {appDescription && <p className="rich-text" dangerouslySetInnerHTML={{ __html: appDescription }} />}
                </div>
                <FilterComponent />
            </div>

            <div className="space-top-xl">
                <p>
                    (Showing {currentItems.length} of {filteredItems.length} items)
                </p>
            </div>

            {currentItems.length === 0 ? (
                <div>
                    <p>No items found for the selected filter.</p>
                </div>
            ) : (
                <>
                    <div className="grid grid-eq-3 space-top-xl">
                        {currentItems.map((item, index) => (
                            <BlockItem key={`${startIndex + index}`} item={item} />
                        ))}
                    </div>

                    {filteredItems.length > perPage && (
                        <Pagination
                            currentPage={currentPage}
                            totalCount={filteredItems.length}
                            pageSize={perPage}
                            onPageChange={handlePageChange}
                            siblingCount={1}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default App;